import React from 'react';
import classNames from 'classnames';
import { Parser as HtmlToReactParser } from 'html-to-react';

import Checkbox from '@mui/material/Checkbox';
import CheckIcon from '@mui/icons-material/Check';

const htmlToReactParser = new HtmlToReactParser();

const ClassNames = {
    'Opt-in 1': 'ecal-reg-field-optin',
    'Opt-in 2': 'ecal-reg-field-secondary_optin',
    'Opt-in 3': 'ecal-reg-field-optin3',
    'Opt-in 4': 'ecal-reg-field-optin4',
};

function renderOptin (p) {
    const {
        key,
        optinValues,
        updateOptinValues,
        optin,
        classes,
    } = p;

    function getChecked () {
        const target =  optinValues[`${optin.name}`];
        if (target) {
            return target.value;
        }
        return optin.isSelected;
    }

    function getClassName () {
        if (optin?.name) {
            return ClassNames[optin?.name];
        }
        return 'ecal-reg-field-optin';
    }

    return (
        <div
            key={key}
            className={classNames([getClassName(), classes.optinItem])}
            onClick={(e) => {
                updateOptinValues({
                    [optin.name]: {
                        value: !getChecked(),
                        isSelected: !getChecked(),
                        ...optin,
                    },
                });
            }}
        >
            <Checkbox
                id={`${getClassName()}-checkbox`}
                className={classNames(['ecal-reg-field-optin-checkbox', classes.optinItemCheck])}
                checked={getChecked()}

                value={getChecked()}
                icon={<div className={classNames(['ecal-reg-field-optin-checkbox-untick', classes.checkUntick])}> </div>}
                checkedIcon={<div className={classNames(['ecal-reg-field-optin-checkbox-ticked', classes.checkTicked])}>
                    <CheckIcon style={{ fontSize: '10px' }}/>
                </div>}
            />
            <span
                id={`${getClassName()}-label`}
                value={getChecked()}
                className={classNames(['ecal-reg-field-optin-label', classes.optinItemText])}
            >
                {htmlToReactParser.parse(optin.message)}
            </span>
        </div>
    );
}

export default renderOptin;